import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'

import {
    FormItemReqNo,
    FormItemSfName,
    FormItemSfNo,
} from '../UC/FormChooseUc.jsx'

export default function FormChooseUc(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemSfNo />
            <FormItemSfName />
            <FormItemReqNo />
        </FormChooseExternal>
    )
}
